module.exports = __webpack_public_path__ + "media/images/gallery/ce_off-67369b9ce1f804d816d8e186a728bc46.gif";